export enum BenefitsVerificationTasks {
  callPayer = 3,
  callPBM = 4,
  sendSummary = 5,
}
